export const AVAILABLE = 'AVAILABLE';
export const AWAY = 'AWAY';
export const BUSY = 'BUSY';
export const INACTIVE = 'INACTIVE';
export const OFFLINE = 'OFFLINE';
export const UNKNOWN = 'UNKNOWN';